<template>
    <div class="input-group service-searchbar">
        <div class="filtered-search-wrapper">
            <div class="form-control filtered-search filtered-search-box-input-container droplab-dropdown">
                <ul class="tokens-container list-unstyled">
                    <visual-token
                            :active="token===activeToken" :blur="blurred" :lookup="getTokenOptions" :select="selected"
                            :token="token" @submit="submitToken"
                            v-for="token in tokens"
                            v-on:token:remove="removeToken"
                            :resultConfig="resultConfig"
                    />
                </ul>
            </div>
        </div>
        <div class="input-group-select">
            <button type="button" class="btn btn-default dropdown-toggle form-control" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                {{ $t("service_search.category_placeholder") }} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu checkbox-menu allow-focus">
                <li
                        v-for="service in services"
                        :key="'option-' + service.id"
                >
                    <label :for="service.id" @click="(e) => e.stopPropagation()">
                        <input
                                :id="service.id"
                                @change="selectCategory($event)"
                                :value="service.id"
                                type="checkbox"
                                :checked="isActiveService(service)"
                        /> {{ $t("service." + service.id) }}
                    </label>
                </li>
            </ul>
        </div>
        <span class="input-group-btn">
            <button @click="submit" class="btn btn-default" type="button">
                <i class="icon si-search"></i></button>
        </span>
    </div>
</template>

<script>
    import VisualToken from "./VisualToken";
    import {mapState} from "vuex";


    const tokenKeys = [{
        key: 'product',
        type: 'string',
        param: 'product',
        symbol: '@',
    }, {
        key: 'assignee',
        type: 'string',
        param: 'username',
        symbol: '@',
    }, {
        key: 'milestone',
        type: 'string',
        param: 'title',
        symbol: '%',
    }, {
        key: 'label',
        type: 'array',
        param: 'name[]',
        symbol: '~',
    }, {
        key: 'category',
        type: 'array',
        param: 'category[]',
        symbol: '/',
    }];

    const alternativeTokenKeys = [{
        key: 'label',
        type: 'string',
        param: 'name',
        symbol: '~',
    }];

    const tokenKeysWithAlternative = tokenKeys.concat(alternativeTokenKeys);

    const conditions = [{
        url: 'assignee_id=0',
        tokenKey: 'assignee',
        value: 'none',
    }, {
        url: 'milestone_title=No+Milestone',
        tokenKey: 'milestone',
        value: 'none',
    }, {
        url: 'milestone_title=%23upcoming',
        tokenKey: 'milestone',
        value: 'upcoming',
    }, {
        url: 'label_name[]=No+Label',
        tokenKey: 'label',
        value: 'none',
    }];

    class FilteredSearchTokenKeys {
        static get() {
            return tokenKeys;
        }

        static getSymbols() {
            return tokenKeys.map((i) => i.symbol);
        }

        static getAlternatives() {
            return alternativeTokenKeys;
        }

        static getConditions() {
            return conditions;
        }

        static searchByKey(key) {
            return tokenKeys.find(tokenKey => tokenKey.key === key) || null;
        }

        static searchBySymbol(symbol) {
            return tokenKeys.find(tokenKey => tokenKey.symbol === symbol) || null;
        }

        static searchByKeyParam(keyParam) {
            return tokenKeysWithAlternative.find((tokenKey) => {
                let tokenKeyParam = tokenKey.key;

                if (tokenKey.param) {
                    tokenKeyParam += `_${tokenKey.param}`;
                }

                return keyParam === tokenKeyParam;
            }) || null;
        }

        static searchByConditionUrl(url) {
            return conditions.find(condition => condition.url === url) || null;
        }

        static searchByConditionKeyValue(key, value) {
            return conditions
                .find(condition => condition.tokenKey === key && condition.value === value) || null;
        }
    }


    export default {
        name: "VisualTokenSearch",
        props: ['value', 'resultConfig', 'query'],
        components: {
            VisualToken
        },
        data: function () {
            return {
                input: "",
                inputToken: {
                    type: 'input',
                    value: ""
                },
                activeToken: null,
                tokens: []
            }
        },
        computed: {
            ...mapState({
                services: state => state.services
            }),
            search() {
                let q = "";
                q = this.tokens.map((i) => {
                    if (i.type === 'input') {
                        return i.value
                    }

                    return i.type + ":" + (i.symbol ? i.symbol : '') + i.value
                }).join(" ");

                //this.$emit('input', q);
                return q;
            },
            inputWatcher() {
                return this.inputToken.value;
            }
        },
        watch: {
            query(newVal, oldVal) {
                if (this.search !== newVal) {
                    this.init();
                }
            },
            inputWatcher(val) {
                if (val == "")
                    return;
                var result = this.processTokens(val);

                if (result.tokens.length) {
                    this.tokens.push.apply(this.tokens, result.tokens);
                    var inputIndex = this.tokens.indexOf(this.inputToken);
                    var lastToken = this.tokens.slice(-1)[0];
                    this.inputToken.value = result.searchToken;
                    if (result.searchToken == "") {
                        result.searchToken = lastToken.value;
                        lastToken.value = "";
                    }
                    this.selected(lastToken);
                }
            }
        },
        methods: {
            isActiveService({id}) {
                return this.$store.getters.isSearchCategory(id);
            },
            selectCategory(event) {
                const category = event.target.value;

                this.$store.commit('selectSearchCategory', category || null);
            },
            submit() {
                this.$emit('input', this.search);
                this.$emit('submit', this.search);
            },
            submitToken() {
                this.submit();
            },
            getResults() {

            },
            getTokenOptions($token) {
            },
            removeToken(e) {
                if (e === this.inputToken) {
                    const index = this.tokens.indexOf(this.inputToken);
                    if (this.activeToken) {
                        const activeIndex = this.tokens.indexOf(this.activeToken);
                        this.tokens.splice(activeIndex, 1);
                        this.activeToken = null;
                    }
                    const lastToken = this.tokens[Math.max(index - 1, 0)];
                    if (lastToken !== this.inputToken)
                        this.selected(lastToken);
                } else {
                    const index = this.tokens.indexOf(e);
                    this.tokens.splice(index, 1);
                }
            },
            selected($token) {
                this.activeToken = $token;
                this.addInputToken($token);
            },
            addInputToken($token) {
                if (!$token) {
                    return;
                }
                let index = this.tokens.indexOf($token);
                const inputToken = this.inputToken;
                inputToken.value = $token.value;
                const inputIndex = this.tokens.indexOf(inputToken);

                if (inputIndex >= 0) {
                    this.tokens.splice(inputIndex, 1);
                    if (inputIndex < index)
                        index--;
                }

                this.tokens.splice(index + 1, 0, inputToken);
            },
            blurred($token) {
                if (!this.activeToken)
                    return;
                var index = this.tokens.indexOf(this.inputToken);
                this.tokens.splice(index, 1);
                this.activeToken.value = this.inputToken.value;
                this.activeToken = null;
                this.inputToken.value = "";
                this.tokens.push(this.inputToken);
            },
            processTokens(input) {

                const allowedKeys = FilteredSearchTokenKeys.get().map(i => i.key);
                // Regex extracts `(token):(symbol)(value)`
                // Values that start with a double quote must end in a double quote (same for single)
                const tokenRegex = new RegExp(`(${allowedKeys.join('|')}):([~%@]?)(?:('[^']*'{0,1})|("[^"]*"{0,1})|(\\S?))`, 'g');
                const tokens = [];
                let lastToken = null;
                if (!input) {
                    input = "";
                }
                const searchToken = input.replace(tokenRegex, (match, type, symbol, v1, v2, v3) => {
                    let tokenValue = v1 || v2 || v3;
                    let tokenSymbol = symbol;

                    if (!FilteredSearchTokenKeys.getSymbols().indexOf(tokenValue)) {
                        tokenSymbol = tokenValue;
                        tokenValue = '';
                    }

                    tokens.push({
                        type,
                        value: tokenValue || '',
                        symbol: tokenSymbol || '',
                    });
                    return '';
                }).replace(/\s{2,}/g, ' ').trim() || '';

                if (tokens.length > 0) {
                    const last = tokens[tokens.length - 1];
                    const lastString = `${last.key}:${last.symbol}${last.value}`;
                    lastToken = input.lastIndexOf(lastString) ===
                    input.length - lastString.length ? last : searchToken;
                } else {
                    lastToken = searchToken;
                }

                return {
                    tokens,
                    lastToken,
                    searchToken,
                };
            },
            init() {
                this.input = this.query;
                const result = this.processTokens(this.input);
                this.tokens.splice(0, this.tokens.length);
                this.tokens.push.apply(this.tokens, result.tokens);
                this.inputToken.value = result.lastToken;
                this.tokens.push(this.inputToken);
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style lang="less">

</style>
